<div *ngIf="isLobbyLoaded && (IsRpFavWidgetEnabled || isAbRecentlyPlayedWidget) && !isAbRecentlyPlayedContainer">
    <cc-rp-fav-widget [lobbyType]="lobbyType" [gameContainer]="'PageContainer'"></cc-rp-fav-widget>
    <cc-rcp-fav-logout-widget [lobbyType]="lobbyType"></cc-rcp-fav-logout-widget>
</div>
